<template>
  <div class="Create alignment">
    <template>
      <v-flex xs12 sm12>
        <h3 v-if="edit" class="styleHeader" style="margin-bottom: 31px">
          {{ $t("pages.Customer.Create.CommittenteAggiungi") }}
        </h3>
        <h3 v-else class="styleHeader" style="margin-bottom: 31px">
          {{ $t("pages.Customer.Create.CommittenteModifica") }}
        </h3>
        <v-card class="styleDataTable">
          <form>
            <v-text-field
              class="styleAlignementCard"
              v-model="name"
              :label="$t('pages.Customer.Create.LabelNome')"
              required
              :error-messages="nameErrors"
              @input="$v.name.$touch()"
              @blur="$v.name.$touch()"
            ></v-text-field>
            <v-select
              v-model="stockSelected"
              :items="stocks"
              item-text="name"
              item-value="id"
              :label="$t('pages.Customer.Create.LabelSito')"
              required
              :error-messages="stockSelectedErrors"
              @change="
                $v.stockSelected.$touch();
                onChange($event);
              "
              @blur="$v.stockSelected.$touch()"
            ></v-select>
            <v-select
              v-model="codiceASSelected"
              :items="codiceAS"
              :label="$t('pages.Customer.Create.LabelCodiceAs')"
              autocomplete
              required
              :error-messages="codiceASSelectedErrors"
              item-text="Code"
              @input.native="loadAltKN($event)"
              @change="onChange($event)"
            ></v-select>
            <v-text-field
              v-model="codiceSocieta"
              :label="$t('pages.Customer.Create.LabelCodiceSocietà')"
              required
              :error-messages="codiceSocietaErrors"
              @input="$v.codiceSocieta.$touch()"
              @blur="$v.codiceSocieta.$touch()"
            ></v-text-field>
          </form>
        </v-card>
        <v-btn
          class="white--text styleButtonTop styleAlignementSaveButton"
          @click="submit()"
          color="#279947"
        >
          <v-icon left>check_circle</v-icon>
          {{ $t("pages.Customer.Create.Salva") }}
        </v-btn>
        <v-btn class="styleButtonTop" @click="back()">
          <v-icon left>remove_circle</v-icon>
          {{ $t("pages.Customer.Create.Annulla") }}
        </v-btn>
      </v-flex>
      <v-alert :value="errorAlert" type="error" transition="scale-transition">
        {{ errorMessage }}
      </v-alert>
    </template>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import customersApi from "../../apiSmartLogistics/customersApi";
import stocksApi from "../../apiSmartLogistics/stocksApi";
import router from "@/router/index.js";
import searchPartnersApi from "../../apiMasterData/SearchPartnersApi";
import debounce from "debounce";
import { Trans } from "@/plugins/Translation";
export default {
  mixins: [validationMixin],
  validations: {
    name: { required },
    stockSelected: { required },
    codiceSocieta: { required },
    codiceASSelected: { required }
  },

  data: () => ({
    id: 0,
    name: "",
    stocks: [],
    stockSelected: "",
    codiceSocieta: "",
    codiceASSelected: "",
    codiceAS: [],
    errorAlert: false,
    errorMessage: ""
  }),

  computed: {
    edit() {
      return this.$route.params.id;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required &&
        errors.push(this.i18n.t("Validations.CampoObbligatorio"));
      return errors;
    },
    stockSelectedErrors() {
      const errors = [];
      if (!this.$v.stockSelected.$dirty) return errors;
      !this.$v.stockSelected.required &&
        errors.push(this.i18n.t("Validations.CampoObbligatorio"));
      return errors;
    },
    codiceSocietaErrors() {
      const errors = [];
      if (!this.$v.codiceSocieta.$dirty) return errors;
      !this.$v.codiceSocieta.required &&
        errors.push(this.i18n.t("Validations.CampoObbligatorio"));
      return errors;
    },
    codiceASSelectedErrors() {
      const errors = [];
      if (!this.$v.codiceASSelected.$dirty) return errors;
      !this.$v.codiceASSelected.required &&
        errors.push(this.i18n.t("Validations.CampoObbligatorio"));
      return errors;
    },
    supportedLanguages() {
      return Trans.supportedLanguages;
    },
    currentLanguage() {
      return Trans.currentLanguage;
    },
    i18n() {
      return Trans.i18n;
    }
  },

  created() {
    const id = this.$route.params.id;
    if (id) {
      customersApi.GetCustomer(id).then(response => {
        this.name = response.data.name;
        this.stockSelected = response.data.stock;
        this.codiceSocieta = response.data.codiceSocieta;
        this.codiceAS = [response.data.codiceAS];
        this.codiceASSelected = response.data.codiceAS;
      });
    }

    stocksApi.GetStocksInternal().then(response => {
      this.stocks = response.data;
    });
  },
  methods: {
    back() {
      router.push("/" + this.currentLanguage + "/Customers/Index");
    },

    submit() {
      this.$v.$touch();
      const id = this.$route.params.id;
      if (
        this.$v.name.$error ||
        this.$v.stockSelected.$error ||
        this.$v.codiceSocieta.$error ||
        this.$v.codiceASSelected.$error
      ) {
        return;
      }

      let customer = {
        id: id,
        name: this.name,
        stock: this.stockSelected,
        codiceSocieta: this.codiceSocieta,
        codiceAS: this.codiceASSelected
      };

      if (id) {
        customersApi
          .UpdateCustomer(customer)
          .then(() => {
            router.push("/" + this.currentLanguage + "/Customers/Index");
          })
          .catch(error => {
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });
      } else {
        customersApi
          .AddCustomer(customer)
          .then(() => {
            router.push("/" + this.currentLanguage + "/Customers/Index");
          })
          .catch(error => {
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });
      }
    },
    onChange() {
      let search = {
        altkn: this.codiceASSelected,
        stockId: this.stockSelected
      };

      stocksApi.GetCodiceSocieta(search).then(response => {
        this.codiceSocieta = response.data;
      });
    },
    clear() {
      this.$v.$reset();
      this.name = "";
      this.stockSelected = "";
      this.codiceSocieta = "";
      this.codiceASSelected = "";
    },
    loadAltKN: debounce(function(event) {
      if (event.target.value.length > 2) {
        let searchItem = {
          Code: event.target.value,
          partnersSearchType: 0
        };

        searchPartnersApi.SearchPartners(searchItem).then(({ data }) => {
          this.codiceAS = data;
          event.target.value = data;
        });
      }
    }, 200)
  }
};
</script>
